import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Title from '../components/Title';
import { setSlotNameById } from '../../../flow/actions';

const defaultProps = {
  title: ''
};
const propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string
};

class EditableTitle extends PureComponent {
  state = {
    isEditing: false
  };

  handleChange = val => this.props.setSlotNameById(this.props.id, val);
  handleDbClick = () => this.setState({ isEditing: true });
  handleBlur = () => this.setState({ isEditing: false });

  render() {
    const { isEditing } = this.state;
    const { title } = this.props;
    return (
      <div onDoubleClick={this.handleDbClick} style={{ minWidth: 200 }}>
        <Title
          title={title}
          isEditing={isEditing}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ dashboardSettings }, ownProps) => {
  const { id } = ownProps;
  const slotData = dashboardSettings.details.slots.find(s => s.id === id) || {};
  return {
    title: slotData.name
  };
};
const mapDispatchToProps = {
  setSlotNameById
};
EditableTitle.defaultProps = defaultProps;
EditableTitle.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditableTitle);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/EditableTitle/container/index.jsx